import {
    GOOGLE_AUTH_FAILED,
    GOOGLE_AUTH_START,
    GOOGLE_AUTH_SUCCESS,
    GOOGLE_PAGE_TOKEN,
    GOOGLE_PAGINATION_SUCCESS,
    SAVE_EMAIL_IN_REDUX,
    MICROSOFT_PAGE_LINK
} from "../actionTypes/emailSettings";

export const initialState = {
    isLoading: false,
    token: '',
    userId: null,
    emailData: {},
    pagination: [],
    currentPage: 0,
    microsoftPagination: [],
    microsoftCurrentPage: 0
}


//pagination: { currentPage: 0, tokens: [{page: 1, token: ''}]}
const emailSettings = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_EMAIL_IN_REDUX:
            let userEmail = { email: action.data.email, isVerifying: true, valid: false, authToken: '', refreshToken: '', expiresIn: 0 }
            return {
                ...state,
                emailData: { ...userEmail }
            }
        case GOOGLE_AUTH_START:
            return {
                ...state,
                isLoading: true,
            };
        // data: { authToken: tokenDetails?.access_token, email: res?.data?.emailAddress, refreshToken: data?.refreshToken, expiresIn: tokenDetails?.expires_in }
        case GOOGLE_AUTH_SUCCESS:
            let tmpEmails = []
            let isEmailExist = state?.authEmails.findIndex((authEmail) => authEmail?.email === action?.data?.email)
            if (isEmailExist === -1) {
                tmpEmails = [...state?.authEmails]
            } else {
                tmpEmails = state?.authEmails.filter((authEmail) => authEmail?.email !== action?.data?.email)
            }
            let obj = { email: action?.data?.email, domain: action?.data?.domain, token: { accessToken: action?.data?.authToken, expiresIn: action?.data?.expiresIn } }
            tmpEmails.push(obj)
            return {
                ...state,
                isLoading: false,
                authEmails: tmpEmails
            }
        case GOOGLE_AUTH_FAILED:
            return {
                ...state,
                isLoading: false,
            }

        case GOOGLE_PAGE_TOKEN:
            if (action.data.pageClicked === 1) {
                state.currentPage = state?.currentPage + 1
                state.pagination = [...state?.pagination, { prevPageToken: state?.pagination[state?.pagination?.length - 1]?.nextPageToken, currentPage: state?.pagination[state?.pagination?.length - 1]?.currentPage + 1, nextPageToken: action?.data?.pageToken || '' }]
            } else if (action.data.pageClicked === -1) {
                state.currentPage = state?.currentPage - 1
                state.pagination = state?.pagination.slice(0, -1);
            } else {
                let tokenObj = { prevPageToken: '', currentPage: 1, nextPageToken: action?.data?.pageToken }
                state.emailData = {}
                state.pagination = []
                state.pagination.push(tokenObj)
                state.currentPage = 1
            }

            return {
                ...state
            }

        case MICROSOFT_PAGE_LINK:
            if (action.data.pageClicked === 1) {
                state.microsoftCurrentPage = state?.microsoftCurrentPage + 1
                state.microsoftPagination = [...state?.microsoftPagination, { prevPageToken: state?.microsoftPagination[state?.microsoftPagination?.length - 1]?.nextPageToken, microsoftCurrentPage: state?.microsoftPagination[state?.microsoftPagination?.length - 1]?.currentPage + 1, nextPageToken: action?.data?.pageLink || '' }]
            } else if (action.data.pageClicked === -1) {
                state.microsoftCurrentPage = state?.microsoftCurrentPage - 1
                state.microsoftPagination = state?.microsoftPagination.slice(0, -1);
            } else {
                let tokenObj = { prevPageToken: '', currentPage: 1, nextPageToken: action?.data?.pageLink }
                state.emailData = {}
                state.microsoftPagination = []
                state.microsoftPagination.push(tokenObj)
                state.microsoftCurrentPage = 1
            }

            return {
                ...state
            }
        default:
            return state
    }
}

export default emailSettings

